import { DonationFormShell } from '@web/components/page-components/DonationForm'
import { DialogBackdrop, DialogContent, DialogRoot } from '@web/components/atoms/Modal'
import { DonationForm as DonationFormProps } from '@web/graphql-components'
import DonationFormFinalStep from './PageComponent/DonationForm/DonationFormFinalStep'
import { useState } from 'react'
import { Branding } from '@web/components/utils/branding/useBrandingsStore'
import { useMergeFields } from '@web/components/page-components/Text/MergeTags/MergeTag'
import { useShallow } from 'zustand/react/shallow'
import { useSubmitQuickPayValuesMutation } from '../libs/queries'
import { toBrandCssVariable } from '@web/components/molecules/ColorPicker/utils'
import environment from '../libs/environment'
import { DONOR_MERGE_TAGS } from '@web/components/page-components/Text/MergeTags/utils'
import { usePageStore } from '../libs/hooks/usePageStore'
import { usePaymentStore } from '../libs/hooks/usePaymentStore'

type FieldCollectionPopup = {
  donationForm: DonationFormProps
  branding: Branding | null
  onSubmit?: () => void
}

const [FIRST_NAME_TAG, LAST_NAME_TAG, , , MOBILE_TAG] = DONOR_MERGE_TAGS

const FieldCollectionPopup = ({ donationForm, branding, onSubmit }: FieldCollectionPopup) => {
  const [isOpen, setIsOpen] = useState(true)
  const { buttonData, colorData } = branding ?? {}
  const amount = usePageStore((state) => state.amount)
  const formValues = useMergeFields(
    useShallow((state) => {
      return {
        extraFields: {
          firstName: state.mergeFields.get(FIRST_NAME_TAG.MergeFieldSettingId) ?? '',
          lastName: state.mergeFields.get(LAST_NAME_TAG.MergeFieldSettingId) ?? '',
          mobile: state.mergeFields.get(MOBILE_TAG.MergeFieldSettingId) ?? '',
        },
      }
    }),
  )
  const { mutateAsync: submitValues } = useSubmitQuickPayValuesMutation()
  return (
    <DialogRoot open={isOpen} onOpenChange={(e) => setIsOpen(e.open)} closeOnInteractOutside={false} placement="top">
      <DialogBackdrop backdropFilter="blur(2px)" />
      <DialogContent
        bgColor="transparent"
        css={{
          '--branding-button-radius': `${buttonData?.cornerRadius}px`,
          '--branding-button-font-family': buttonData?.font.font,
          '--branding-button-font-size': buttonData?.font.fontSize,
          '--branding-button-primary-bg-color': buttonData?.buttonColors['Primary'].bgColor,
          '--branding-button-primary-text-color': buttonData?.buttonColors['Primary'].textColor ?? '#FFFFFF',
          '--branding-button-primary-hover-bg-color': buttonData?.buttonColors['Primary'].hoverBgColor,
          '--branding-button-primary-hover-text-color': buttonData?.buttonColors['Primary'].hoverTextColor ?? '#FFFFFF',
          '--branding-button-secondary-bg-color': buttonData?.buttonColors['Secondary'].bgColor,
          '--branding-button-secondary-hover-bg-color': buttonData?.buttonColors['Secondary'].hoverBgColor,
          ...Object.keys(colorData ?? {})
            .map((key) => ({ [toBrandCssVariable(key)]: colorData?.[key] }))
            .reduce((acc, val) => Object.assign(acc, val), {}),
        }}
      >
        <DonationFormShell
          donationFormProps={{ ...donationForm, styles: { ...donationForm?.styles, backgroundColorOpacity: '1' } }}
          googleMapsApiKey={environment.googleMapsApiKey}
          formValues={{ amount, ...formValues }}
          steps={[
            <DonationFormFinalStep
              key="final-step"
              {...donationForm}
              onSubmit={(input) => {
                submitValues(input)
                setIsOpen(false)
                usePaymentStore.setState({ showDataCollectionPopup: false })
                onSubmit?.()
              }}
            />,
          ]}
        />
      </DialogContent>
    </DialogRoot>
  )
}

export default FieldCollectionPopup
